<div id="main-nav" class="nav-container">
  <mat-toolbar class="mbp-toolbar">
    <ng-content select="[nav-toggle]"></ng-content>
    <a routerLink="/" class="mbp-brand" aria-label="Home">
      <span class="mbp-brand__logo">MBP</span>
      <span class="mbp-brand__name">Magaliesberg Pharmaceuticals</span>
    </a>
    <span class="spacer"></span>
    <span class="mbp-toolbar__tagline">Administration portal</span>
    <ng-content select="[sign-in]"></ng-content>
    <ng-content select="[account]"></ng-content>
  </mat-toolbar>
  @if (isLoading) {
    <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
  }
</div>
